import { Select } from "@headlessui/react";
import { useEffect, useState } from "react";
import { classNames } from "../../../helpers/classNames";

const Select2 = ({
  dropdownData = [],
  value,
  onChange = () => {},
  placeholder,
  isSearch = false,
  xPlacement = "bottomLeft",
  flip = true,
  dropdownClass,
  dropdownButtonClass,
  optionsClass,
  onSearchHandler = () => {},
  onScroll = () => {},
  loading,
  label,
  labelClasses,
  errorType,
  errorText,
  required,
  isDisabled = false,
  checked = true,
  buttonStyle,
  icon,
  clearBtn,
  className,
  ...props
}) => {
  const [list, setList] = useState([]);

  useEffect(() => {
    setList(dropdownData);
  }, [dropdownData]);

  return (
    <Select
      name="status"
      aria-label="Project status"
      value={value}
      className={classNames(
        "relative w-full h-12 flex items-center gap-2 pr-6 pl-3 rounded-full bg-slate-50 border text-sm text-slate-800 !ring-0 !outline-0 focus:border-text-disabled transition-all duration-200",
        className
      )}
      onChange={(e) => {
        if (e.target.value !== "selectOption") {
          onChange(
            e.target.value,
            dropdownData?.find((item) => item?.value === e.target.value)
          );
        } else {
          onChange(undefined, undefined);
        }
      }}
    >
      <option value="selectOption">{placeholder || "Select options"}</option>
      {list?.map((item, i) => (
        <option key={`${item?.value}${i}`} value={item?.value}>
          {item?.name || item?.label}
        </option>
      ))}
    </Select>
  );
};

export default Select2;
